import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";

import "./project-perimeter-info.scss";
import {Project} from "../../models/project";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";
import {Icon} from "../../core/components/icon/icon";
import {Button, Popup} from "semantic-ui-react";


export interface ProjectPerimeterInfoProps {
    auftragsverwaltung: Auftragsverwaltung;
    project: Project;
}

@observer
export class ProjectPerimeterInfo extends Component<ProjectPerimeterInfoProps, any> {

    constructor(props: ProjectPerimeterInfoProps) {
        super(props);
        this.state = {
            perimeters: []
        };
    }

    componentDidMount() {
        this.loadPerimeters();
    }


    render(): React.ReactElement | null {
        const {auftragsverwaltung, project} = this.props;
        const {perimeters} = this.state;

        if (perimeters && perimeters.length > 0) {
            return (
                <div>
                    <Popup content="Projektperimeter vorhanden"
                        trigger={
                            <Icon className="geo-icon-present" name="ok" selected />
                        } />
                    <Button className="map geo-link-button"
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            this.handleShowMap();
                        }}>
                        {/* eslint-disable-next-line max-len */}
                        Perimeter anzeigen
                    </Button>
                </div>
            );
        }
        else {
            return (
                <div>
                    <Popup content="Projektperimeter fehlt"
                        trigger={
                            <Icon className="geo-icon-missing" name="sign_warning_harmful" selected />
                        } />
                    {project?.isAlterable && !auftragsverwaltung.isEditing &&
                        <Button className="editing geo-link-button"
                            onClick={(e: React.MouseEvent) => {
                                e.preventDefault();
                                this.handleStartEditingPerimeter();
                            }}>
                            Perimeter erfassen
                        </Button>
                    }
                </div>
            );
        }
    }

    private loadPerimeters(): void {
        const {auftragsverwaltung, project} = this.props;
        if (!project?.id) {
            this.setState({
                perimeters: []
            });
            return;
        }

        auftragsverwaltung.ProjectPerimeterStore.loadItems(project.id).then((perimeters) => {
            this.setState({
                perimeters
            });
        });
    }

    private handleStartEditingPerimeter(): void {
        const {auftragsverwaltung} = this.props;
        auftragsverwaltung.setShowMap(true);

        const {isEditing} = auftragsverwaltung;
        if (!isEditing) {
            auftragsverwaltung.setEditing(true, "perimeter");
            return;
        }
    }

    private handleShowMap(): void {
        const {auftragsverwaltung} = this.props;
        auftragsverwaltung.setShowMap(true);
    }

}
